<div class="bl-historical-search">
  <a
    tabindex="-1"
    title="Historical Search"
    [ngClass]="{
      'bl-historical-search--active bl-historical-search--active':
        currentPageHistoricalSearch === true,
      'bl-historical-search--selected': activeHistoricalSearch === true
    }"
    (click)="showHistorical()"
    class="bl-menu__link"
  >
    <!--span for="historical-search" class="bl-historical-search__text" data-attr="Historical Search"
      >Historical Search</span
    >
    <span class="bl-historical-search__margin-icon-search">
      <i class="fas fa-search"></i>
    </span-->
    <i class="fas fa-search"></i>
    <span  class="bl-menu__text" >Historical Search</span>

      <!--span
        *ngIf="activeNav"
        [ngClass]="{
          'bl-menu__link--step-selected bl-menu__corner':
            steps && steps[i] && steps[i].stepSelected ? true : false,
          'bl-menu__link--disabled': steps && steps[i] && steps[i].disabled ? true : false
        }"
      >
      </span-->
  </a>
</div>
